export default __webpack_public_path__ + "static/media/fondo.d047c64a.jpg";